import React from "react";
import { FaCheckCircle, FaStar, FaThumbsUp } from "react-icons/fa";
import testimonialImage1 from "../assets/Job Finder.png";
import testimonialImage2 from "../assets/Job Finder.png";
import testimonialImage3 from "../assets/Job Finder.png";

function WhyChooseUs() {
  const benefits = [
    {
      icon: <FaCheckCircle className="text-4xl text-indigo-500 mb-4" />,
      title: "Experienced Team",
      description:
        "Our team has years of experience in delivering top-notch design and development services.",
    },
    {
      icon: <FaStar className="text-4xl text-indigo-500 mb-4" />,
      title: "Quality Assurance",
      description:
        "We ensure the highest quality standards in every project we undertake.",
    },
    {
      icon: <FaThumbsUp className="text-4xl text-indigo-500 mb-4" />,
      title: "Customer Satisfaction",
      description:
        "Our clients' satisfaction is our top priority, and we strive to exceed their expectations.",
    },
  ];

  const testimonials = [
    {
      name: "John Doe",
      feedback: "Amazing service! Highly recommend.",
      company: "Company A",
      image: testimonialImage1,
    },
    {
      name: "Jane Smith",
      feedback: "The team was professional and delivered on time.",
      company: "Company B",
      image: testimonialImage2,
    },
    {
      name: "Sam Wilson",
      feedback: "Great experience from start to finish.",
      company: "Company C",
      image: testimonialImage3,
    },
  ];

  return (
    <div className="bg-gradient-to-r from-indigo-400 to-purple-600 text-gray-900 p-8 min-h-screen">
      <div className="container mx-auto py-10">
        <h1 className="text-4xl font-bold mb-8 text-center text-white">
          Why Choose Us?
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white text-gray-800 p-6 rounded-lg shadow-lg text-center transform hover:scale-105 transition duration-300 ease-in-out"
            >
              {benefit.icon}
              <h2 className="text-2xl font-bold mb-2">{benefit.title}</h2>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>

        <h2 className="text-3xl font-bold mb-8 text-center text-white">
          What Our Clients Say
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white text-gray-800 p-6 rounded-lg shadow-lg text-center transform hover:scale-105 transition duration-300 ease-in-out"
            >
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-24 h-24 rounded-full mx-auto mb-4"
              />
              <p className="text-xl font-semibold mb-2">
                "{testimonial.feedback}"
              </p>
              <p className="text-lg font-bold">{testimonial.name}</p>
              <p className="text-md">{testimonial.company}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WhyChooseUs;
